import React from "react";
import { Button } from "@project-stories/elements/Button/Button";

const ButtonBlock = ({ settings, blocks }) => (
    <div
        className={`buttons-container flex flex-wrap gap-4 mt-4 self-${settings.content_alignment_mobile} lg:self-${settings.content_alignment_desktop}`}
    >
        {blocks.map((block, index) => {
            if (block.type !== 'button_cta') return null;
            
            const isLink = block.settings.cta_style_type === 'link';
            
            return (
                <div key={block.key || index} className={`pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px]`}>
                    {block.settings.button_text && (
                        <Button
                            label={block.settings.button_text}
                            style={block.settings.button_style || "primary"}
                            styleType={block.settings.cta_style_type || "button"}
                            link={block.settings.button_url}
                            icon={block.settings.button_icon || (isLink ? "" : "right-arrow-alt")}
                            reverse={false} // Icon after text
                        />
                    )}
                </div>
            );
        })}
    </div>
);

export default ButtonBlock;
